import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/fontawesome-free-solid'
//import {Collapse} from 'react-collapse'
import Scrollspy from 'react-scrollspy'
import Scroll from './Scroll'

class Nav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      responsiveCollapsed: true,
    };
    // This binding is necessary to make `this` work in the callback
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  // Closes responsive menu when a scroll trigger link is clicked
  toggleMenu(event) {
    this.setState({responsiveCollapsed: !this.state.responsiveCollapsed});
    //document.querySelector('.navbar-collapse').style.display = 'none';
  }

  handleScroll(event) {
    //let pos = event.target.body.querySelector('.masthead').scrollTop;
    let pos = window.pageYOffset;
    if (pos > 100) {
      this.setState({collapsed: true});
    } else {
      this.setState({collapsed: false});
    }
  }

  render() {
    const navClassName = 'navbar navbar-expand-lg navbar-light fixed-top' + (this.state.collapsed ? ' navbar-shrink' : '');
    const menuBtnClassName = 'navbar-toggler navbar-toggler-right' + (this.state.responsiveCollapsed ? ' collapsed' : '');
    const navBarResponsiveClassName = 'collapse navbar-collapse' + (this.state.responsiveCollapsed ? '' : ' show');
    //const menuBtnClassName = 'navbar-toggler navbar-toggler-right';
    //const navBarResponsiveClassName = 'collapse navbar-collapse';
    return (
      <nav className={navClassName} id="mainNav">
        <div className="container">
          <Scroll type="id" element="page-top" offset={5}>
            <a className="navbar-brand js-scroll-trigger" href="#page-top">Basebit</a>
          </Scroll>
          <button className={menuBtnClassName} type="button" onClick={this.toggleMenu} data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            Menu&nbsp;
            <FontAwesomeIcon icon={faBars} />
          </button>
          <div className={navBarResponsiveClassName} id="navbarResponsive">
            <Scrollspy items={ ['about', 'team', 'signup'] } currentClassName="active" className="navbar-nav ml-auto" offset={0}>
              <li className="nav-item">
                <Scroll type="id" element="about" clickHandler={this.toggleMenu} offset={5}>
                  <a className="nav-link js-scroll-trigger" href="#about">About</a>
                </Scroll>
              </li>
              <li className="nav-item">
                <Scroll type="id" element="team" clickHandler={this.toggleMenu} offset={5}>
                  <a className="nav-link js-scroll-trigger" href="#projects">Team</a>
                </Scroll>
              </li>
              <li className="nav-item">
                <Scroll type="id" element="signup" clickHandler={this.toggleMenu} offset={5}>
                  <a className="nav-link js-scroll-trigger" href="#signup">Contact</a>
                </Scroll>
              </li>
            </Scrollspy>
          </div>
        </div>
      </nav>
    );
  }
}

export default Nav


// WEBPACK FOOTER //
// ./src/components/Nav.js